import classNames from 'classnames'
import * as PropTypes from 'prop-types'
import ReactCursorPosition from 'react-cursor-position'

import customCursorStyles from './CustomCursor.css'

import {
  IconChevronLeft,
  IconChevronRight,
  IconPlay,
  IconPlus
} from '/react/library/Icons'

const defaultPropTypes = {
  onClick: PropTypes.func.isRequired
}

class CustomCursorContainer extends React.PureComponent {
  static propTypes = {
    ...defaultPropTypes,
    children: PropTypes.node.isRequired
  }

  state = {
    isTouched: false
  }

  containerRef = React.createRef()

  handleOnTouchStart = () => {
    this.setState({ isTouched: true })
  }

  render () {
    const {
      children,
      ...restProps
    } = this.props

    const {
      isTouched
    } = this.state

    const cursorProps = {
      icons: children,
      isTouched,
      ...restProps
    }

    return (
      <div
        className={customCursorStyles.container}
        onTouchStart={this.handleOnTouchStart}
        ref={this.containerRef}
      >
        <ReactCursorPosition>
          <Cursor {...cursorProps} />
        </ReactCursorPosition>
      </div>
    )
  }
}

class Cursor extends React.PureComponent {
  static propTypes = {
    ...defaultPropTypes,
    icons: PropTypes.node.isRequired,
    isTouched: PropTypes.bool.isRequired
  }

  isMousePositionLeft = () => {
    const position = this.props.position
    const elementDimensions = this.props.elementDimensions

    return position.x < elementDimensions.width / 2
  }

  handleClick = () => {
    this.props.onClick({
      isMousePositionLeft: this.isMousePositionLeft()
    })
  }

  render () {
    const {
      icons,
      isPositionOutside,
      isTouched,
      position: {
        x = 0,
        y = 0
      } = {}
    } = this.props

    let activeIconIndex = 0
    const hasDoubleIcons = React.Children.count(icons) === 2
    const isInActive = isPositionOutside || isTouched

    if (hasDoubleIcons) activeIconIndex = this.isMousePositionLeft() ? 0 : 1

    return (
      <div
        className={customCursorStyles.clickContainer}
        onClick={this.handleClick}
      >
        <div
          className={classNames(
            customCursorStyles.cursor,
            {
              [customCursorStyles.cursorIsInActive]: isInActive
            }
          )}
          style={{
            transform: `translate3d(${x}px, ${y}px, 0)`
          }}
        >
          {hasDoubleIcons
            ? icons[activeIconIndex]
            : icons
          }
        </div>
      </div>
    )
  }
}

export class CustomCursorNextPrevious extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <CustomCursorContainer {...this.props}>
        <IconChevronLeft isLight />
        <IconChevronRight isLight />
      </CustomCursorContainer>
    )
  }
}

export class CustomCursorPlay extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <CustomCursorContainer {...this.props}>
        <IconPlay isLight />
      </CustomCursorContainer>
    )
  }
}

export class CustomCursorPlus extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <CustomCursorContainer {...this.props}>
        <IconPlus isLight />
      </CustomCursorContainer>
    )
  }
}
